module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/triangle-gray@2x-2a1ef20f3e1120c0f1931c6aad933abf.png";